export function getEnvironment() {
    if (typeof window !== 'undefined') {
        if (
            window.location.pathname.split('/')[1] === 'dev' ||
            window.location.origin ===
            'https://front-backoffice-ativos-avalia-gab-dev.aguiabranca.com.br' ||
            window.location.hostname === 'localhost'
        ) {
            return 'dev'
        }

        if (
            window.location.pathname.split('/')[1] === 'qas' ||
            window.location.origin ===
            'https://front-backoffice-ativos-avalia-gab-qas.aguiabranca.com.br'
        ) {
            return 'qas'
        }

        if (
            window.location.pathname.split('/')[1] === 'hmg' ||
            window.location.origin ===
            'https://front-backoffice-ativos-avalia-gab-hmg.aguiabranca.com.br'
        ) {
            return 'hmg'
        }

        return 'prd'
    }
}

export function getUrlApi(location?: string, version: string = 'v1') {
    if (typeof window !== 'undefined') {
        const environment = getEnvironment()
        if (location === 'login') {
            return `https://service-backoffice-ativos-avalia-gab-apiaut-${environment}.aguiabranca.com.br/api/${version}`
        }
        return `https://service-backoffice-ativos-avalia-gab-${environment}.aguiabranca.com.br/api/${version}`
    }
}

export function getToken() {
    if (typeof window !== 'undefined') {
        return localStorage.getItem('avalia-token')
    }
}

export function setStorage(chave: string, valor: string) {
    if (typeof window !== 'undefined') {
        localStorage.setItem(chave, valor)
    }
}
